import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const KeyboardEnterIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props} data-test-id="keyboard-enter-icon" viewBox="0 0 32 32">
    <path d="M25 6a1 1 0 0 1 1 1v11a3 3 0 0 1-3 3H9.414l3.293 3.293a1 1 0 0 1-1.414 1.414l-4.646-4.646-.104-.115a1.5 1.5 0 0 1 .104-2.007l4.646-4.647a1 1 0 0 1 1.414 1.415L9.414 19H23a1 1 0 0 0 1-1V7a1 1 0 0 1 1-1Z" />
  </BaseIcon>
);
